import { OnReady } from "taskpane/models/types";
import useQuery from "./useQuery";
import { encodeUriParams } from "taskpane/utils";

interface IAimsid {
  aimsid: string;
}

export interface IEndSession extends IAimsid {
  apiUrl: string;
}

export interface IEndSessionResponse {
  response: {
    statusCode: number;
    statusText: string;
    data: {};
  };
}

const useQueryEndSession = (params: IEndSession, onReady?: OnReady<IEndSessionResponse>) => {
  const { aimsid, apiUrl } = params;
  const url: string = `${apiUrl}/wim/aim/endSession`;
  const queryParams: IAimsid = {
    aimsid: aimsid,
  };

  useQuery(`${url}${encodeUriParams(queryParams)}`, "POST", onReady);
};

export default useQueryEndSession;
